import { useState, useCallback } from "react"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import '../Forms.css'
import TextInput from '../FormComponents/TextInput/TextInput.js'
import {API_ROOT} from '../../AppConfig/app-config.js'
import { Navigate } from "react-router-dom"
import { Alert } from 'react-bootstrap'

export default function LoginForm() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [message, setMessage] = useState(null);

    const renderMessage = useCallback(() => {
        if(message !== null && loggedIn === false){
            return (
                <div className="container formStyle">
                    <Alert variant="danger">
                        <Alert.Heading>Error</Alert.Heading>
                        {message}
                    </Alert>
                </div>
            )
        }
    }, [message, loggedIn]);

    if(message !== null && loggedIn === true){
        return(
            <div>
                <Navigate to="/booking" />
            </div>
        );
    }

    return(
        <div>
            <Formik
                initialValues={{
                    email: "",
                    password: "",
                }}
                validationSchema={Yup.object({
                    email: Yup.string()
                    .email("Invalid email address")
                    .required("Required"),
                    password: Yup.string()
                    .required("Required"),
                })}
                onSubmit={
                    async (values, { setSubmitting }) => {
                    await new Promise(r => setTimeout(r, 500));
                    setMessage(null);
                    fetch(`${API_ROOT}/login`, {
                        credentials: 'include',
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(values)
                    })
                    .then(response => response.json()
                        .then(data => ({status: response.status, returnedBody: data})))
                    .then(returnedObj => {
                        const strMsg = returnedObj.returnedBody.msg;
                        if (returnedObj.status === 200){
                            setMessage(strMsg);
                            setLoggedIn(true);
                        } else {
                            setMessage(strMsg);
                            setLoggedIn(false);
                        }
                    })
                    .catch(error => {
                        console.error("Login error:", error);
                        setMessage("Something went wrong. Please try again.");
                        setLoggedIn(false);
                    })
                    .finally(() => {
                        setSubmitting(false);
                    });
                }}
            >
                <div className="formContainer">
                    <p> Sign in to <em> Torna Campsites </em></p>
                    {renderMessage()}
                    <hr/>
                    <div className="formStyle">
                        <Form method="POST">
                            <TextInput
                                name="email"
                                type="email"
                                placeholder="Email Address"
                            />
                            <TextInput
                                name="password"
                                type="password"
                                placeholder= "Password"
                            />
                            <button
                                className="buttonStyle"
                                type="submit"
                            >
                                Submit
                            </button>
                        </Form>
                    </div>
                    <hr/>
                    <p> New to Torna Campsites? <a href="/signup"> Sign up </a></p>
                </div>
            </Formik>
        </div>
    );
}
